module.exports = __webpack_public_path__ + "assets/step-3-c1180f4b715b2efbc9dfd532a9ad25c4.png";